//libraries
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faToggleOn, faToggleOff, faCircle, faUserPen, faRightFromBracket, faAddressCard, faCircleQuestion} from '@fortawesome/free-solid-svg-icons'
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';

//css
import '../styles/Profile.css';

//js
import Ripples from 'react-ripples';
import { env } from '../assets/env';
import { darkBlueThemeColor } from '../assets/colors-setup';


export function Profile({user, setUser, socket, setSocket, profileImgHash, deviceType})
{
      const navigate=useNavigate();


      async function toggleTeacherMode()
	{
		if(user===false) return alert('Please login to access this feature');

            let res=await axios.post('/toggleTeacherMode');

            if(res.data.status==='lock')
            {
                  const willProceed=window.confirm('You will need to send direct message to our facebook page to turn ON teacher mode for your account.\n\nDo you want to proceed?');

                  if(willProceed) window.open(env.facebookPageLink);
                  else return;
            };

            if(res.data.status==='toggle')
            {
                  const newTeacherMode=res.data.newTeacherMode;

                  let userClone=JSON.parse(JSON.stringify(user));
                  userClone.teacherMode=newTeacherMode;
                  setUser(userClone);
            };
	};

      async function logout()
      {
            let res=await axios.post('/logout', {deviceType});

            if(res.data.willLogout===true)
            {
                  setUser(false);
                  if(socket!==false) socket.disconnect();
                  setSocket(false);

                  navigate('/login');
            };
      };


      return<>
            <div className="d-flex justify-content-center rounded-bottom pt-3" style={{marginBottom: '-20px', paddingBottom: '40px', backgroundColor: darkBlueThemeColor}}>
                  <div className="d-flex userNameImgBox">

                        <img className='rounded-circle ml-3' src={`${env.backendBaseUrl}/profileImages/${user.id_users}.jpg?${profileImgHash}`} onError={(e)=>e.target.src=require('../assets/default-profile-image.jpg')} style={{height: '60px', width: '60px', objectFit: 'cover'}} />

                        <div className="text-dark d-flex align-items-center ml-2">
                              <div className="font-weight-bold text-white">{user===false ? 'Guest' : user.username}</div>
                        </div>

                  </div>
            </div>

            <div className="container p-0 optionsBox">

                  <Ripples className="d-flex justify-content-between mb-5 menu-items-bg-color py-2 px-3 mx-3 shadow-sm menuItem" onClick={toggleTeacherMode}>
                        <div>Teacher mode</div>
                        {user.teacherMode==='on' ?
                              <div className='text-success'><FontAwesomeIcon icon={faToggleOn} size='xl' /></div>
                        :
                              <div className='text-dark'><FontAwesomeIcon icon={faToggleOff} size='xl' /></div>
                        }
                  </Ripples>


                  <div>

                        <Ripples onClick={()=>navigate('/editProfile')} className="menuItem mb-2 menu-items-bg-color py-3 px-3 d-flex justify-content-between">
                              <div><FontAwesomeIcon icon={faUserPen} className='mr-2 lightAsh' /> Edit profile</div>
                              <div className="lightAsh"><b>{'>'}</b></div>
                        </Ripples>

                        <Ripples onClick={()=>navigate('/how-to-use')} className="menuItem mb-2 menu-items-bg-color py-3 px-3 d-flex justify-content-between">
                              <div><FontAwesomeIcon icon={faCircleQuestion} className='mr-2 lightAsh' /> How to use</div>
                              <div className="lightAsh"><b>{'>'}</b></div>
                        </Ripples>

                        { (user.teacherMode==='on') &&
                              <Ripples onClick={()=>navigate('/manageOffers')} className="menuItem mb-2 menu-items-bg-color py-3 px-3 d-flex justify-content-between">
                                    <div><i className="fa-solid fa-address-card lightAsh"></i> <span className='ml-2'>My offers</span></div>
                                    <div className="lightAsh"><b>{'>'}</b></div>
                              </Ripples>
                        }

                        { (user===false) ?
                              <div className='mb-5' style={{marginTop: '5rem'}}>
                                    <Ripples onClick={()=>navigate('/login')} className="menuItem menu-items-bg-color py-3 px-3 d-flex justify-content-between">
                                          <div className='text-success'>
                                                <i className="fa-solid fa-right-to-bracket"></i>
                                                <span className='ml-2'>Login</span>
                                          </div>
                                    </Ripples>
                              </div>
                        :
                              <div className='mb-5' style={{marginTop: '5rem'}}>
                                    <Ripples onClick={logout} className="menuItem menu-items-bg-color py-3 px-3 d-flex justify-content-between">
                                          <div className='text-danger'>
                                                <i className="fa-solid fa-right-from-bracket"></i>
                                                <span className='ml-2'>Logout</span>
                                          </div>
                                    </Ripples>
                              </div>
                        }

                  </div>

            </div>

      </>
};
